import template from './sw-cms-block-image-two-column.html.twig';
import './sw-cms-block-image-two-column.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
